export const readableVatReturnStatus = [
  'Temporary',
  'Submitted',
  'Processed',
  'Error',
];

export const readableVatReturnState = {
  A: 'Active',
  N: 'New',
  U: 'Update Request',
  H: 'History',
  E: 'Exclusion Request',
};
